const lessonData = {

        2: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "Sergeant Ruiz",
              image:
                "https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/2025-01/military-woman-female-beauty-fashion-80fbcc.jpg",
              order: 0,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "4", current_scene: "2", previous_scene: "1",text: "Continue" },
          ],
          scene_number: "2",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Sergeant Jasmine Ruiz is a soldier in the 570th Transportation Battalion, currently stationed in Texas. She is a 25-year-old woman whose job is as a mechanic. Sergeant Ruiz likes her job and the opportunity it has afforded her to gain skills and leadership experience over the last five years in the Army.</p><p>She joined the Army with a complicated family history, found she likes working with her hands, and that she is good at it. She was promoted quickly through the ranks and now supervises other mechanics.</p>

            <p>Sergeant Ruiz is on her third assignment. She was first stationed in the northeast of the U.S., and then in Korea. She is now happy to be a little closer to home and family. She has been with the 570th for about a year. Her time in her new unit had been largely positive until two months ago when Staff Sergeant Joe Saunders arrived.</p>`,
          ],
          title: "Meet Sergeant Ruiz",
          videos: [],
          audio: [],
        },
        
        4: {
          checkpoint: false,
          last: false,
          checkpoints: [], 
          images: [
            {
              alt: "Staff Sergeant Saunders",
              image:
                "https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/2025-01/fresno-native-earns-the-rank-of-staff-sergeant-in-the-marine-corps-a2536c.jpg",
              order: 0,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "5", current_scene: "4", previous_scene: "2",text: "Continue" },
          ],
          scene_number: "4",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Staff Sergeant Saunders oversees ordering and distributing supplies for Sergeant Ruiz's Company. Saunders is not her direct supervisor, but he outranks Ruiz, and their jobs require them to interact on nearly a daily basis. Saunders showed an inordinate interest in Ruiz and her personal life from the day he arrived.</p>

            <p>Ruiz rebuffed Saunders' initial approaches which became increasingly confrontational, so that even others began to take notice of their exchanges. Since Staff Sergeant Saunders arrived Ruiz has tried to carry on with her normal job  duties, but she finds this more and more difficult.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        5: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "The motor pool",
              image:
                "https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/2025-01/9038551456_b08182dda7_c.jpg",
              order: 0,
            },
          ],
          layoutNumber: 4,
          navigation: [
            { available_scene: "6", current_scene: "5", previous_scene: "4",text: "Continue" },
          ],
          scene_number: "5",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You, the chaplain, arrived at the unit just a few weeks prior to Staff Sergeant Saunders and took time getting to  know the unit, its culture, and its people. Sergeant Ruiz has had several conversations with you during this time. These interactions were mostly positive. She talked to you during visits to the motor pool while she worked on vehicles. The conversations were about casual topics - the vehicles she was fixing or upcoming training exercises - but at times delved deep into topics like family and hopes for the future.</p>`,
          ],
          title: "The Chaplain",
          videos: [],
          audio: [],
        },
        6: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [{alt: "Your office", image: "https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/2025-01/20150805_1445301.jpg", order: 0} ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "7", current_scene: "6", previous_scene: "5",text: "Continue" },
          ],
          scene_number: "6",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>This morning, Sergeant Ruiz ran into the Religious Affairs Specialist's office to ask if she could speak with you.</p>

            <p>You had been preparing a briefing for the commander, but you put this aside to welcome her in. "Come on in, Sergeant Ruiz. Have a seat."</p>
            
            <p>She sat, catching her breath.</p> 
            
            <p>"Do you want me to shut the door?" you ask.</p>
            <p>"Yes please," Sergeant Ruiz responds. As you close the door, Ruiz starts speaking, "I'm not really religious, and maybe not even very spiritual, but I didn't know who else to come to."</p>  
            </p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },    
        7: {
          checkpoint: false,
          last: false,
          checkpoints: [{
            alt: null,
            answer: false,
            content_type: 5,
            data:
              `<ul><li>What went well in this situation? What tactics did the chaplain use to engage Sergeant Ruiz effectively?</li>
              <li>What role did the Chain of Command play in relation to this situation?</li>
              <li>When does a responsibility for care end, and what boundaries for care exist?</li>
              <li>What responsibility does the chaplain have to care for the alleged perpetrator?</li>
              </ul>`,
            order: 0,
            question_type: 2,
            scene_number: "7",
            sidebar: false,
          }],
          images: [],
          layoutNumber: 9,
          navigation: [
            { available_scene: "10", current_scene: "7", previous_scene: "6",text: "Continue" },
          ],
          scene_number: "7",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: null,
          videos: [],
          audio: [],
        },
        
        10: {
          checkpoint: false,
          last: true,
          checkpoints: [],
          images: [],
          layoutNumber: 6,
          navigation: [{available_scene: "10", current_scene: "10", previous_scene: "7",text: "End Lesson" }],
          scene_number: "10",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You finished this lesson! In this lesson, you explored the role military chaplains can play in cases of alleged sexual assault. You reflected on how chaplains can care for victims and perpetrators of sexual assault in the near and long-term.</p>`
          ],
          title: "Lesson complete",
          videos: [],
          audio: [],
        },
      };
    
export default lessonData;
